import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

export interface registerRequest {
    category: string;
    company: string;
    boss?: string; // 대표자
    mobile: string;
    printer: string;
    label: string;
    printerLabel: string;
    invoice: string;
    bag: string;
    post: string;
    address1: string;
    address2: string;
    contents: string;
}

export interface registerResponse {
    statusCode: number;
    message: string;
}

export const usePostRegisterTracking = (
    successCallback?: (data: registerResponse) => void,
): UseMutationResult<registerResponse, Error, registerRequest, unknown> => {
    return useMutation<registerResponse, Error, registerRequest>({
        mutationFn: async (registerData: registerRequest) => {
            const response = await axiosInstance.post(enum_api_uri.post_register_tracking, registerData);
            return response.data;
        },
        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
